<template>
  <footer class="fixed-bottom text-center">
    <div class="footer-content container pt-3">
      <div class="d-flex flex-column align-items-center mb-0">
        <img src="../assets/logo.jpg" alt="" class="rounded-circle nav-logo" />
        <p class="text-warning mb-0 ms-1 fs-5">My Book List Website</p>
      </div>
      <hr class="mb-1 mt-1" />
      <p class="mb-0 text-white">&copy; Copyright 2022 Haytham El-Gebaly</p>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style>
footer {
  height: 120px;
  background-color: rgba(0, 0, 0, 0.271);
}
</style>
